import React, { FC, useState } from 'react';
import clsx from 'clsx';
import { FixtureElement, Tournament } from '../../../models/api/codegen/code';
import { MatchItem } from './MatchItem';
import { ReactComponent as CLOSED } from '../icons/closedSport.svg';
import { ReactComponent as OPEN } from '../icons/openSport.svg';
import { useNavigate } from 'react-router-dom';

interface ITournamentItem {
    tournament: Tournament;
    fixturesMap: Record<number, FixtureElement[]>;
    toggleCategory: (id: number) => void;
    sportId: number;
    route: string;
}

export const TournamentItem: FC<ITournamentItem> = ({ tournament, fixturesMap, toggleCategory, sportId, route }) => {
    const fixtures = fixturesMap[tournament.ti];
    const [isTournamentOpened, setIsTournamentOpened] = useState<boolean>(false);
    const navigate = useNavigate();

    const handleClick = () => {
        setIsTournamentOpened(p => !p);
        toggleCategory(tournament.ti)
    }

    const handleClickAndNavigate = () => {
        setIsTournamentOpened(p => !p);
        toggleCategory(tournament.ti)
        navigate(route + sportId + "/" + tournament.ci + "/" + tournament.ti)
    }

    return (
        <div>
            <div
                className={clsx(
                    'grid grid-cols-[1fr_25px_2px] items-center justify-between cursor-pointer border-b-[2px]',
                    isTournamentOpened
                        ? 'border-[#FF0000]'
                        : 'border-transparent'
                )}

            >
                <li
                    key={tournament.ti}
                    className={clsx(
                        'flex items-center mt-[12px] mb-[8px] text-[14px] ml-[48px] list-none h-full',
                        isTournamentOpened ? 'text-[#73BCFF]' : 'text-[#C6C7C9]'
                    )}
                    onClick={handleClickAndNavigate}
                >
                    {tournament.tn}
                </li>
                <div
                    className="flex items-center h-full w-full"
                    onClick={e => {
                        e.stopPropagation();
                        handleClick();
                    }}
                >
                    <span>{isTournamentOpened ? <CLOSED /> : <OPEN />}</span>
                </div>
                <div/>
            </div>

            <div className="text-[13px] text-[#C6C7C9] cursor-pointer bg-[#171A1E]">
                {isTournamentOpened &&
                    fixtures.map((match: FixtureElement, index) => <MatchItem key={index} match={match}
                                                                              route={route} />)}
            </div>
        </div>
    );
};
